module.exports = {
	buildObject: function (loadType, loadPath) {
		module.exports.soundscapeObject = {
			soundscape1: {
                soundscapeName: "moody intro",
                '--main-background': 'rgba(241, 254, 255, 1)',
                '--main-accentBackground': 'rgba(209, 226, 255, 1)',
                '--main-textColor': 'rgba(100, 80, 75, 1)',
                '--main-sliderColor' : 'rgba(204, 198, 171, 1)',
                '--main-sliderTextColor': 'rgba(223, 235, 250, 1)',
                angle: '30deg',
                layer1 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'introFlutter' + loadType,
                layer2 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'introBliss' + loadType,
                layer3 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'introDreams' + loadType
            },
            soundscape2: {
            	soundscapeName: "Anger",
                '--main-background': 'rgba(140, 0, 0, 1)',
                '--main-accentBackground': 'rgba(255, 0, 0, 1)',
                '--main-textColor': 'rgba(255, 254, 241, 1)',
                '--main-sliderColor' : 'rgba(100, 0, 0, 1)',
                '--main-sliderTextColor': 'rgba(255, 0, 0, 1)',
                angle: '45deg',
                layer1 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'annoy' + loadType,
                layer2 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'anger' + loadType,
                layer3 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'rage' + loadType
            },
            soundscape3: {
            	soundscapeName: "Interest",
                '--main-background': 'rgba(255, 165, 0, 1)',
                '--main-accentBackground': 'rgba(255, 137, 37, 1)',
                '--main-textColor': 'rgba(10, 10, 10, 1)',
                '--main-sliderColor' : 'rgba(224, 70, 21, 1)',
                '--main-sliderTextColor': 'rgba(255, 165, 0, 1)',
                angle: '25deg',
                layer1 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'interest' + loadType,
                layer2 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'anxious' + loadType,
                layer3 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'vigliant' + loadType
            },
            soundscape4: {
            	soundscapeName: "Joy",
                '--main-background': 'rgba(232, 215, 12, 0.25)',
                '--main-accentBackground': 'rgba(255, 209, 12, 1)',
                '--main-textColor': 'rgba(10, 10, 10, 1)',
                '--main-sliderColor' : 'rgba(255, 195, 12, 1)',
                '--main-sliderTextColor': 'rgba(255, 250, 0, 1)',
                angle: '180deg',
                layer1 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'serene' + loadType,
                layer2 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'joy' + loadType,
                layer3 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'ecstasy' + loadType
            },
            soundscape5: {
                soundscapeName: "Trust",
                '--main-background': 'rgba(7, 217, 154, 1)',
                '--main-accentBackground': 'rgba(89, 255, 82, 1)',
                '--main-textColor': 'rgba(0, 0, 0, 1)',
                '--main-sliderColor' : 'rgba(25, 100, 10, 1)',
                '--main-sliderTextColor': 'rgba(89, 255, 82, 1)',
                angle: '0deg',
                layer1 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'acceptance' + loadType,
                layer2 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'trust' + loadType,
                layer3 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'love' + loadType
            },
            soundscape6: {
            	soundscapeName: "Sadness",
                '--main-background': 'rgba(158, 197, 223, 1)',
                '--main-accentBackground': 'rgba(0, 130, 217, 1)',
                '--main-textColor': 'rgba(0, 0, 25, 1)',
                '--main-sliderColor' : 'rgba(27, 64, 89, 1)',
                '--main-sliderTextColor': 'rgba(0, 200, 255, 1)',
                angle: '222deg',
                layer1 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'pensive' + loadType,
                layer2 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'sadness' + loadType,
                layer3 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'grief' + loadType   
            },
            soundscape7: {
            	soundscapeName: "Disgust",
                '--main-background': 'rgba(115, 55, 2, 1)',
                '--main-accentBackground': 'rgba(242, 152, 119, 0.5)',
                '--main-textColor': 'rgba(242, 225, 175, 1)',
                '--main-sliderColor' : 'rgba(90, 33, 217, 1)',
                '--main-sliderTextColor': 'rgba(225, 50, 255, 1)',
                angle: '79deg',
                layer1 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'bored' + loadType,
                layer2 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'disgust' + loadType,
                layer3 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'loath' + loadType
            },
            soundscape8: {
                soundscapeName: "Distraction",
                '--main-background': 'rgba(151, 4, 191, 1)',
                '--main-accentBackground': 'rgba(242, 159, 5, 1)',
                '--main-textColor': 'rgba(255, 254, 241, 1)',
                '--main-sliderColor' : 'rgba(184, 108, 217, 1)',
                '--main-sliderTextColor': 'rgba(242, 159, 5, 1)',
                angle: '15deg',
                layer1 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'distraction' + loadType,
                layer2 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'surprise' + loadType,
                layer3 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'amaze' + loadType
            },
            soundscape9: {
                soundscapeName: "Fear",
                '--main-background': 'rgba(33, 33, 32, 1)',
                '--main-accentBackground': 'rgba(6, 5, 5, 1)',
                '--main-textColor': 'rgba(200, 200, 200, 1)',
                '--main-sliderColor' : 'rgba(25, 20, 20, 1)',
                '--main-sliderTextColor': 'rgba(200, 200, 200, 1)',
                angle: '180deg',
                layer1 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'uneasy' + loadType,
                layer2 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'fear' + loadType,
                layer3 : process.env.BASE_URL + 'sounds/soundscapes' + loadPath + 'terror' + loadType,
            },
		}
	},

	soundscapeMixing: function (soundscape, level) {
		let level1 = 0, level2 = 0.35, level3 = 0.65, level4 = 1;
		let mixObject = {};
		let CleanSubmix = 1, 
			audioGainLayer1 = 0, 
			audioGainLayer2 = 0, 
			audioGainLayer3 = 0, 
			dynamicText = "",
			selectedSoundscapeDisplay = "";


		switch(soundscape){
			case "moody intro":
				if ((level >= level1) && (level < level2)){
					audioGainLayer1 = 1; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 0; 
					dynamicText = `Emotions are what make us human.`;
					selectedSoundscapeDisplay = `moody`;

		        } else if ((level >= level2) && (level < level3)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 1; 
					audioGainLayer3 = 0; 
					dynamicText = `It is only through understanding our emotions that we can begin to understand ourselves.`;
					selectedSoundscapeDisplay = `is`;

		        } else if ((level >= level3) && (level <= level4)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 1; 
					dynamicText = `If we make room for our emotions, instead of escaping them, we can learn how they fit into the bigger picture of our emotional story.`;
					selectedSoundscapeDisplay = `moody`;
		        }
			break;
			case "Joy":
				if ((level >= level1) && (level < level2)){
					audioGainLayer1 = 1; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 0; 
					dynamicText = `Serenity is splendid and we bask in its beauty.`;
					selectedSoundscapeDisplay = `Serenity`;

		        } else if ((level >= level2) && (level < level3)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 1; 
					audioGainLayer3 = 0; 
					dynamicText = `The forest floor has a story to tell. It too feels the sun's light.`;
					selectedSoundscapeDisplay = `Joyful`;

		        } else if ((level >= level3) && (level <= level4)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 1; 
					dynamicText = `Ecstatic feelings washed over and took hold. Manic actions follow closely. So good! So good?`;
					selectedSoundscapeDisplay = `Ecstasy`;
		        }
			break;
			case "Sadness":
				if ((level >= level1) && (level < level2)){
					audioGainLayer1 = 1; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 0; 
					dynamicText = `Left only with your thoughts. Are you comfortable?`;
					selectedSoundscapeDisplay = `Pensive`;

		        } else if ((level >= level2) && (level < level3)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 1; 
					audioGainLayer3 = 0; 
					dynamicText = `Overbearing sadness is a burden we all face.`;
					selectedSoundscapeDisplay = `Sadness`;

		        } else if ((level >= level3) && (level <= level4)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 1; 
					dynamicText = `What if this humpback whale's communications were never reciprocated?`;
					selectedSoundscapeDisplay = `Grief`;
		        }
			break;
			case "Anger":
				if ((level >= level1) && (level < level2)){
					audioGainLayer1 = 1; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 0; 
					dynamicText = `This wouldn't be suggested as casual listening.`;
					selectedSoundscapeDisplay = `Annoyed`;

		        } else if ((level >= level2) && (level < level3)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0.35; 
					audioGainLayer3 = 0; 
					dynamicText = `Your thoughts align, but do you question the motive? Steady, but unsteady.`;
					selectedSoundscapeDisplay = `Angered`;

		        } else if ((level >= level3) && (level <= level4)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 1; 
					dynamicText = `Like oil to fire, rage ignites. Pity those caught in its unforgiving path.`;
					selectedSoundscapeDisplay = `Rageful`;
		        }
			break;
			case "Trust":
				if ((level >= level1) && (level < level2)){
					audioGainLayer1 = 1; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 0; 
					dynamicText = `If we established a relationship, where would we root its foundation? Is this effort difficult to sustain?`;
					selectedSoundscapeDisplay = `Acceptance`;

		        } else if ((level >= level2) && (level < level3)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 1; 
					audioGainLayer3 = 0; 
					dynamicText = `What if our relationship strengthened and its roots grew deeper?`;
					selectedSoundscapeDisplay = `Trust`;

		        } else if ((level >= level3) && (level <= level4)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 1; 
					dynamicText = `A deep bond was forged between us, love and admiration are freely felt.`;
					selectedSoundscapeDisplay = `Admiration`;
		        }
			break;
			case "Disgust":
				if ((level >= level1) && (level < level2)){
					audioGainLayer1 = 1; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 0; 
					dynamicText = `These winds repeat forever, never gaining nor losing strength.`;
					selectedSoundscapeDisplay = `Bored`;

		        } else if ((level >= level2) && (level < level3)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 1; 
					audioGainLayer3 = 0; 
					dynamicText = `Would the winds of boredom possess your approval? Does your permission even matter? You will become engaged with its texture - as if you had a choice.`;
					selectedSoundscapeDisplay = `Disgusted`;

		        } else if ((level >= level3) && (level <= level4)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 1; 
					dynamicText = `This digusting tornado only grows worse. The sounds of caressed mayonnaise and licking lips forces its way down your ear canals. This is terrible.`;
					selectedSoundscapeDisplay = `Loathing`;
		        }
			break;
			case "Interest":
				if ((level >= level1) && (level < level2)){
					audioGainLayer1 = 1; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 0; 
					dynamicText = `You are the loon. Fiercely territorial. You take great interest into anything that enters your lake. For this lake is your amplifier, your tremolo is its sound.`;
					selectedSoundscapeDisplay = `Interested`;

		        } else if ((level >= level2) && (level < level3)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 1; 
					audioGainLayer3 = 0; 
					dynamicText = `Like a slithering snake, an intruding thought has unknown intentions. Things do not feel right.`;
					selectedSoundscapeDisplay = `Anticipation`;

		        } else if ((level >= level3) && (level <= level4)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 1; 
					dynamicText = `You chase this creeping thought. You must heed, you must act. One needs to be vigliant of their surroundings.`;
					selectedSoundscapeDisplay = `Vigilance`;
		        }
			break;
			case "Distraction":
				if ((level >= level1) && (level < level2)){
					audioGainLayer1 = 1; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 0; 
					dynamicText = `It is difficult to enjoy nature when nature is not enjoying you.`;
					selectedSoundscapeDisplay = `Distracted`;

		        } else if ((level >= level2) && (level < level3)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 1; 
					audioGainLayer3 = 0; 
					dynamicText = `Tune your call, wavelengths of communication are palpable.`;
					selectedSoundscapeDisplay = `Surprised`;

		        } else if ((level >= level3) && (level <= level4)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 1; 
					dynamicText = `The mighty Amazon Rainforest commanded the skies above its canopy. The lungs of our Earth were righteous in their actions.`;
					selectedSoundscapeDisplay = `Amazed`;
		        }
			break;
			case "Fear":
				if ((level >= level1) && (level < level2)){
					audioGainLayer1 = 1; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 0; 
					dynamicText = `What if one spends too much time in the past, worried about the future?`;
					selectedSoundscapeDisplay = `Paranoia`;

		        } else if ((level >= level2) && (level < level3)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 1; 
					audioGainLayer3 = 0; 
					dynamicText = `Delusions are what you make of them. But, perhaps, no? Something else guides this feeling.`;
					selectedSoundscapeDisplay = `Fear`;

		        } else if ((level >= level3) && (level <= level4)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 1; 
					dynamicText = `Motivated by survival, terror is not afraid of its consequences.`;
					selectedSoundscapeDisplay = `Terror`;
		        }
			break;
			default:
				if ((level >= level1) && (level < level2)){
					audioGainLayer1 = 1; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 0; 
					dynamicText = "Dynamic Level 1";

		        } else if ((level >= level2) && (level < level3)){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 1; 
					audioGainLayer3 = 0; 
					dynamicText = "Dynamic Level 2";

		        } else if (level == level3){
					audioGainLayer1 = 0; 
					audioGainLayer2 = 0; 
					audioGainLayer3 = 1; 
					dynamicText = "Dynamic Level 3";
		        }
			break;
		};
			

		module.exports.soundscapeMixingObject = { 
			CleanSubmix: CleanSubmix,
			audioGainLayer1: audioGainLayer1,
			audioGainLayer2: audioGainLayer2,
			audioGainLayer3: audioGainLayer3,
			dynamicText: dynamicText,
			selectedSoundscapeDisplay: selectedSoundscapeDisplay
		}


	}
};